// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__1iBSa","projectBox":"projectBox__3k2ae","projectDescription":"projectDescription__1VXYt"};


//////////////////
// WEBPACK FOOTER
// ./components/project/styles.styl
// module id = +0Aa
// module chunks = 0